import styled, { keyframes, createGlobalStyle } from "styled-components"

export const float = keyframes`
	0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-10px);
	}
	100% {
		transform: translatey(0px);
	}
`

export const fadeInLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(80px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`

export const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`
export const GlobalStyle = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.background};
  }

.control-prefix__control{
  background: ${({ theme }) => theme.object} !important;
  outline: 0 !important;
  border-radius: 10px !important;
  border: none !important;
  padding: 4px 8px;
  margin-right: 16px;
}
.control-prefix__control--is-focused {
  outline: 0 !important;
}
.control-prefix__placeholder{
  color: white !important;
}
.control-prefix__indicator-separator{
  background-color: white !important;
}
.control-prefix__indicator{
  color: white !important;
}
.control-prefix__menu{
  background: ${({ theme }) => theme.object} !important;
  border: none !important;
  border-radius: 16px !important;
}
.control-prefix__option {
  color: white !important;
}
.control-prefix__option--is-focused {
  background: ${({ theme }) => theme.background} !important;
  color: ${({ theme }) => ("dark" ? theme.headerSubtitle : theme.sidebarBackground)} !important;
}
.control-prefix__option--is-selected {
  background: none !important;
  color: white !important;
}
.control-prefix__single-value {
  color: white !important;
}

`
export const ViewRow = styled.div`
  display: flex;
  flex-direction: row;
`
export const ViewColumn = styled.div`
  display: flex;
  flex-direction: column;
`
export const HeaderTitle = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.headerTitle};
  opacity: 0.56;
  font-weight: bold;
  line-height: 1;
`
export const HeaderSubTitle = styled.div`
  font-size: 50px;
  color: ${({ theme }) => theme.headerSubtitle};
  margin: 8px 0 0 0;
  font-weight: bold;
  line-height: 1;
  @media (max-width: 960px) {
    font-size: 30px;
  }
`
export const FilterSelector = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.headerSubtitle};
  margin: 0;
  width: 320px;
`
export const Option = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const OptionImg = styled.img`
  width: 30px;
  height: auto;
  margin: 0 8px 0 0;
`
export const Box = styled.div`
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
  width: auto;
  height: auto;
  background-color: ${({ theme }) => theme.itemBackground};
  border-radius: 34px;
  margin: 0 0 34px 24px;
  padding: 0 24px 24px 24px;
  cursor: pointer;
  transition: 0.2s cubic-bezier(0.17, 0.67, 0.83, 0.67);
  &:hover {
    transform: translateY(-5%);
  }
`
export const CloseButton = styled.div`
  position: absolute;
  border-radius: 10px;
  display: block;
  color: white;
  top: 16px;
  right: 16px;
  font-size: 14px;
  padding: 0 8px;
  border-radius: 50px;
  cursor: pointer;
  font-weight: bold;
`
export const ExpandedBox = styled.div`
  position: relative;
  width: auto;
  flex: 1;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;
  background: ${({ theme }) => theme.expandedBackground};
  border-radius: 34px;
  opacity: 1;
  padding: 3px;
  margin: 0 16px;
  animation: ${fadeInLeft} 1s ease-in-out;
  @media (max-width: 960px) {
    width: auto;
    text-align: center;
    margin: auto;
  }
`
export const ExpandedBoxBackground = styled.div`
  @media (max-width: 960px) {
    align-items: center;
    justify-content: center;
    display: flex;
    padding: 1em;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    backdrop-filter: blur(10px);
    animation: 1s ease-in-out;
    overflow-y: auto;
  }
`

export const Title = styled.h2`
  font-weight: 800;
  font-size: 18px;
  text-align: center;
  color: ${({ theme }) => theme.headerSubtitle};
  margin: 16px 0 0 0;
`

export const Description = styled.h3`
  font-size: 12px;
  color: ${({ theme }) => theme.description};
  opacity: 0.5;
  text-align: center;
  white-space: pre-wrap;
  margin: 8px 21px;
  font-weight: 500;
`

export const Glyph = styled.img`
  animation: ${rotate} 15s linear infinite;
  margin: 0;
  max-width: 190px;
  max-height: 190px;
  width: 190px;
  height: 190px;
  padding: 0;
  margin: 0;
  filter: drop-shadow(0px 0px 2px #fff);
`

export const SubDescription = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.description};
  opacity: 0.54;
  text-align: center;
  font-style: italic;
  padding: 0 21px;
  margin: 0 0 16px 0;
  line-height: 1.2;
`

export const ImageContainer = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FloatContainer = styled.div`
  position: absolute;
  display: inline-block;
  width: auto;
  height: auto;
  animation: ${float} 6s ease-in-out infinite;
  margin: 0;
`

export const ImageBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: space-around;
`

export const StatsBox = styled.div`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.statsBackground};
  border-radius: 32px;
  padding: 24px;
  margin-top: 16px;
`

export const Stats = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 12px;
  justify-content: space-between;
  margin: 0 0 8px 0;
  &:last-child {
    margin: 0;
  }
`
export const StatName = styled.p`
  font-weight: bold;
  color: ${({ theme }) => theme.description};
  text-align: left;
  opacity: 0.65;
  margin: 0;
`
export const Value = styled.p`
  font-weight: normal;
  color: ${({ theme }) => theme.description};
  text-align: right;
  margin: 0;
`
export const Icon = styled.img`
  height: 25px;
  width: auto;
  margin: 0;
`
export const LogoBackground = styled.img`
  width: 40px;
  transform: scale(1.5);
`
export const SidebarContainer = styled.div`
  padding: 24px 16px;
  min-width: max-content;
  height: max-content;
  background: ${({ theme }) => theme.sidebarBackground};
  border-radius: 34px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  @media (min-width: 961px) {
    position: sticky;
    top: 16px;
  }
  @media (max-width: 960px) {
    width: 100%;
    position: fixed;
    bottom: 0;
    flex-direction: row;
    height: auto;
    justify-content: space-between;
    padding: 30px 24px;
    z-index: 2;
    display: ${({ expanded }) => (expanded || expanded === 0 ? "none" : "visible")};
  }
`
export const SidebarText = styled.p`
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.sidebarText};
  margin-top: 8px;
  text-transform: uppercase;
  font-family: Helvetica;
  @media (max-width: 960px) {
    margin: 0;
  }
`
export const Tab = styled.button`
  height: fit-content;
  padding: 12px 30px;
  margin: 0;
  cursor: pointer;
  opacity: 1;
  background: transparent;
  border: 0;
  outline: 0;
  border-radius: 14px;
  color: ${({ theme }) => ("dark" ? "#fff" : "#0079C1")};
  background: ${({ theme, active }) => (active ? theme.object : "transparent")};
`

export const TabLabel = styled.h1`
  font-size: 14px;
  margin: 0;
  padding: 0;
  font-weight: bold;
`
export const ButtonGroup = styled.div`
  display: flex;
  margin: 0 16px 8px 0;
  align-items: center;
  border-radius: 16px;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.object};
`
export const TooltipBox = styled.div`
  background-color: ${({ theme }) => theme.object};
  width: 280px;
  border-radius: 10px;
  padding: 10px 15px;
  position: absolute;
  text-align: center;
  bottom: -182px;
  z-index: 1;
  &:before {
    top: 0;
    left: 50%;
    transform: translate(-50%, calc(-100% - 5px)) rotate(45deg);
  }
  &:after {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, calc(-100% - 10px));
  }
`
export const Footer = styled.footer`
  @media (max-width: 960px) {
    display: ${({ expanded }) => (expanded || expanded === 0 ? "none" : "inherit")};
  }
`
